export function randomInteger(min, max) {
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
  }

export function encode(data){
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }

// export function setCookie(cname, cvalue, exdays) {
//     var d = new Date();
//     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//     var expires = "expires="+d.toUTCString();
//     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//   }
  
// export function getCookie(cname) {
//     var name = cname + "=";
//     var ca = document.cookie.split(';');
//     for(var i = 0; i < ca.length; i++) {
//       var c = ca[i];
//       while (c.charAt(0) === ' ') {
//         c = c.substring(1);
//       }
//       if (c.indexOf(name) === 0) {
//         return c.substring(name.length, c.length);
//       }
//     }
//     return "";
//   }

// export function getCookieRegex(name) {
//   var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
//   return v ? v[2] : null;
// };

export function getCookie(name) {
  try {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith(`${name}=`))
      .split("=")[1];
  } catch (e) {
    console.warn(`No cookie with name: ${name} found!`);
  }
}